import Style from "./MaterialsTableStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import api from "../../services/api";

import { FaTrashAlt } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";

export default function MaterialsTable(props) {
  const [errorMessage, setErrorMessage] = useState("");

  const [deletingMaterial, setDeletingMaterial] = useState(false);
  const [materialToDelete, setMaterialToDelete] = useState({} as any);

  const [materials, setMaterials] = useState([] as any[]);
  const [loadingMaterials, setLoadingMaterials] = useState(true);

  useEffect(() => {
    LoadMaterials();
  }, []);


  async function LoadMaterials() {
    try {
      const result = await api.get("/materials");
      if (result.data.success) {
        const materialsResult = result.data.allMaterials;
        setMaterials(materialsResult);
      }
      else
        console.error("Não pode pegar as os materiais: ", result.data);
    }
    catch (error) {
      console.error("Erro pegando materiais: ", error);
    }
    finally {
      setLoadingMaterials(false);
    }
  }

  async function DeleteMaterial() {
    setDeletingMaterial(true);
    try {
      const result = await api.delete(`/materials/${materialToDelete.id}`);
      if (!result.data.success) {
        setErrorMessage("Não foi possível deletar material");
        console.error("Não foi possível deletar material " + result.data.message);
      }
      else
        setErrorMessage("");
    }
    catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Erro deletando material");
    }
    finally {
      await LoadMaterials();
      setDeletingMaterial(false);
      ClosePopupDeletingMaterial();
    }
  }

  function GoToMaterial(materialId) {
    props.history.push(`/materials/${materialId}`);
  }

  function ClosePopupDeletingMaterial() {
    setMaterialToDelete({});
  }

  return (
    <Style>
      <PageTitle title="Materiais" />
      <Spinner spinning={loadingMaterials} />
      <TwoButtonsModal
        show={materialToDelete.id != null}
        onHide={ClosePopupDeletingMaterial}
        loading={deletingMaterial}
        title="Deleção de material!"
        body={`Você está tentando deletar o material "${materialToDelete.name}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupDeletingMaterial}
        secondaryDisabled={deletingMaterial}
        primaryText="Deletar"
        primaryOnClick={DeleteMaterial}
        primaryDisabled={deletingMaterial}
      />

      {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}

      <section className="table-title">
        <h1>Materiais</h1>
        <button onClick={() => GoToMaterial(0)}>Adicionar Material</button>
      </section>


      <table className="table table-striped table-bordered table-hover main-table">
        <thead >
          <tr>
            <th>Id</th>
            <th>Nome Interno</th>
            <th>Nome de Exibição</th>
            <th>Categoria</th>
            <th>Código do Fornecedor</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {materials?.length > 0 && materials.map(material => {
            return (
              <tr key={material.id}>
                <td onClick={() => GoToMaterial(material.id)} className="clickable">{material.id}</td>
                <td onClick={() => GoToMaterial(material.id)} className="clickable">{material.name}</td>
                <td>{material.displayName}</td>
                <td>{material.category}</td>
                <td>{material.supplierCode}</td>
                <td>
                  <div className="action" onClick={() => setMaterialToDelete(material)}>
                    <FaTrashAlt className="icon" />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>

  )
}